/*
 * MDB shim for Collapse
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Orders/orderList.jsx
 */

import MUICollapse from "@mui/material/Collapse";

export default function Collapse({ children, isOpen, ...rest }) {
  return (
    <MUICollapse in={Boolean(isOpen)} {...rest}>
      {children}
    </MUICollapse>
  );
}
